import { USAGE_CODES as USAGE_ENUMS } from '../PartsForm/types.d';
import { ProviderPartsFormValue } from './ProviderPartsForm';

export const RETURNABLE_YES = 'Yes' as const;
export const RETURNABLE_NO = 'No' as const;

export const isProviderPartsFormValid = (data: ProviderPartsFormValue): boolean => {
  if (!data.usageCode) return false;
  if (!data.partNumber?.trim()) return false;
  if (!data.description?.trim()) return false;
  if (!data.returnable) return false;

  // Return tracking required when returnable is Yes and usage code is not NOT_RECEIVED
  if (
    data.returnable === RETURNABLE_YES &&
    data.usageCode !== USAGE_ENUMS.NOT_RECEIVED &&
    (!data.returnTracking?.trim() || !data.returnCarrier?.trim())
  ) return false;

  return true;
};
